import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const auth = inject(AuthService);
  const snack = inject(MatSnackBar);
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      // Feedback via snackbar with best-effort message
      const msg = (err?.error && (err.error.message || err.error.error || err.error.detail))
        ? (err.error.message || err.error.error || err.error.detail)
        : (err.message || 'Ocorreu um erro inesperado.');

      // Avoid duplicate snackbars for asset requests
      if (!req.url.startsWith('assets/')) {
        snack.open(String(msg), 'Fechar', { duration: 5000, panelClass: ['snackbar-error'] });
      }

      // Auth handling: on any 401, logout and send user to the home page
      if (err.status === 401) {
        try { auth.logout(); } catch {}
        router.navigate(['/']);
      } else if (err.status === 403) {
        // Forbidden → keep user session, just route to home
        router.navigate(['/']);
      }
      return throwError(() => err);
    })
  );
};
